import React from 'react'

import { ReactComponent as HalfpriceIcon } from './Halfprice.svg'

export default (props: any) => <HalfpriceIcon {...props} />
